/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profile_RestoredInputs */

const en_us2_profile_restored = /** @type {(inputs: Profile_RestoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: back in your recommendations`)
};

const pt_br2_profile_restored = /** @type {(inputs: Profile_RestoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: de volta às recomendações`)
};

const es_419_profile_restored = /** @type {(inputs: Profile_RestoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: de vuelta en tus recomendaciones`)
};

const pt_pt2_profile_restored = /** @type {(inputs: Profile_RestoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: de volta às recomendações`)
};

const fr_fr2_profile_restored = /** @type {(inputs: Profile_RestoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} : de retour dans tes recommandations`)
};

const de_de2_profile_restored = /** @type {(inputs: Profile_RestoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: wieder in deinen Empfehlungen`)
};

const it_it2_profile_restored = /** @type {(inputs: Profile_RestoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: di nuovo tra i consigli`)
};

/**
* | output |
* | --- |
* | "{name}: back in your recommendations" |
*
* @param {Profile_RestoredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_restored = /** @type {((inputs: Profile_RestoredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_RestoredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_restored(inputs)
	if (locale === "es-419") return es_419_profile_restored(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_restored(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_restored(inputs)
	if (locale === "de-DE") return de_de2_profile_restored(inputs)
	if (locale === "it-IT") return it_it2_profile_restored(inputs)
	return en_us2_profile_restored(inputs)
});
export { profile_restored as "profile.restored" }